<template>
    <div class="clearfix userCenterView enterpriseCertification">
        <div class="fr"><Bread :prop="bread" /></div>
        <div class="contentWrap fl"  style="width:100%">
            <div class="contentTitle">积分中心</div>
            <div class="content" style="height:450px;">
                <div class="scoreTitle">
                    <div>可用积分: {{ balanceScore }}</div>
                </div>
                <BasicTable 
                :tableData="tableData" 
                :columns="columns" 
                style="height:98%;margin:30px 0;"
                :pageSize="pageQuery.page_size"
                @pageChange="pageChange"
                :total="pageQuery.total">
                    <template v-slot:change_time="{ item }">
                        {{item.change_time*1000 | dateFormat('YYYY-MM-DD') }}
                    </template>
                </BasicTable>
                
            </div>
        </div>
    </div>
</template>

<script>
import Bread from '@/components/Bread/index'
import { UserCenterService } from '../../../service/userCenter.service'

const columns = [
  { name: '订单编号', key: 'order_sn' },
  { name: '获得积分', key: 'pay_points' },
  { name: '创建时间', key: 'change_time',type: 'custom'},
  { name: '备注', key: 'desc' },

];

export default {
    components:{ Bread },
    data() {
        return {
            bread: [{
                name: '用户中心',
                path: '/userCenter/index'
            },{
                name: '积分中心',
                path: '/userCenter/score'
            }],
            tableData:[],
            balanceScore:'',
            columns,
            pageQuery:{
                page: 1,
                total: 0,
                page_size:20
            }
        }
    },
    methods: {
        async getList() {
            const data = await UserCenterService.accountList(this.pageQuery)
            this.balanceScore = JSON.parse(JSON.stringify(data.balanceScore))
            this.tableData = JSON.parse(JSON.stringify(data.list))
            this.pageQuery.total = data.totalRow
        },
        async pageChange(index) {
            this.pageQuery.page = index
            const data = await UserCenterService.accountList(this.pageQuery);
            this.tableData = JSON.parse(JSON.stringify(data.list))
        },
    },
    created() {
        this.getList()
    }
    
}
</script>
<style lang="scss" scoped>
    .userCenterView{
        width: 935px;
        .content{
            padding: 40px 30px 50px 30px;
            border: 1px solid #e3e2e1;
            display: block;
            .scoreTitle{
                font-size: 16px;
                font-weight: 700;
            }
        }
    }
</style>